import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { formatInAppTz } from '../utils/timezone';

const OtherTipsDeleteModal = ({ isOpen, onClose, record, onDelete }) => {
  const handleDelete = async () => {
    const success = await onDelete(record.id, record.role);
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Confirm Deletion</DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-gray-700">
            Are you sure you want to delete this record?
          </p>
          {record && (
            <div className="mt-4 p-4 bg-gray-50 rounded-md">
              <p><strong>Employee:</strong> {record.employee}</p>
              <p><strong>Amount:</strong> ${record.tip_out_cash}</p>
              <p><strong>Date:</strong> {formatInAppTz(record.date)}</p>
            </div>
          )}
        </div>
        
        <div className="flex justify-end space-x-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button 
            variant="destructive"
            onClick={handleDelete}
          >
            Confirm Delete
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OtherTipsDeleteModal;